import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../schema.dexie";
import { emojiAlimento } from "../lib/emoji";
import { ehRefCatalogo, urlIlustracao } from "../lib/catalogoImagens";

/**
 * Mostra a imagem do alimento. A ref (fotos[0]) pode ser:
 *  - "cat:<chave>" → ilustração do catálogo (SVG embutido, data-URI);
 *  - id de Blob   → foto real do usuário (IndexedDB);
 *  - nada         → cai num emoji representativo (nome/categoria).
 * `placeholder` explícito tem prioridade no fallback.
 */
export function FoodPhoto({
  fotoId,
  nome,
  categoria,
  className = "",
  placeholder,
}: {
  fotoId?: string | null;
  nome?: string | null;
  categoria?: string | null;
  className?: string;
  placeholder?: string;
}) {
  const ehCat = ehRefCatalogo(fotoId);

  const blob = useLiveQuery(
    async () => (fotoId && !ehCat ? (await db.foto.get(fotoId))?.blob : undefined),
    [fotoId, ehCat],
  );

  const blobUrl = blob ? URL.createObjectURL(blob) : null;
  const url = ehCat ? urlIlustracao(fotoId!) : blobUrl;
  const glifo = placeholder ?? emojiAlimento(nome, categoria);

  return (
    <div className={`foto ${className}`} aria-hidden={!url}>
      {url ? (
        <img
          src={url}
          alt=""
          onLoad={() => {
            if (blobUrl) URL.revokeObjectURL(blobUrl); // só revoga object URL, não data-URI
          }}
        />
      ) : (
        <span>{glifo}</span>
      )}
    </div>
  );
}
